import React, { useState } from 'react';
import '../Vs_Multiplayer/MultiplayerWelcomePage/multiplayerWelcomePage.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const Subscription = () => {

    const [key, setKey] = useState('Monthly');
    return (
        <>
            <section className='wrapper ginWelcomePage'>
                <div className='bgWelcome'>
                    <div className='main-section subscriptionPage'>
                        <h2 className='text-white text-center mb-3'>Choose your <span className='sbcrptnHead'>right plan!</span></h2>
                        <p className='text-white text-center'>Get easy access to our content with your desired plan. We are excited to offer a special licensing deal to our user.</p>
                    </div>

                    <div className='container subscriptionCards'>
                       <div className='d-flex flex-column align-items-center'>
                       <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3 border-0"
    >
      <Tab eventKey="Monthly" title="Monthly">
      <div className='row p-3'>
                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$49<span>/Month</span></p>
                            <ul className='features'>
                                <li>3-5 day turnaround</li>
                                <li>Native development</li>
                                <li>Task delivered one-by-one</li>
                                <li>Dedicated dashboard</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>

                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$249<span>/Month</span></p>
                            <ul className='features'>
                                <li>1-2 day turnaround</li>
                                <li>Monthly strategy call</li>
                                <li>Commercial licence</li>
                                <li>Native development</li>
                                <li>Task delivered one-by-one</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>

                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$449<span>/Month</span></p>
                            <ul className='features'>
                                <li>Everything in design & development</li>
                                <li>Strategy workshop</li>
                                <li>Priority support</li>
                                <li>Multiple task at once</li>
                                <li>Dedicated dashboard</li>
                                <li>Adavance custom development</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>
                    </div>
      </Tab>
      <Tab eventKey="Yearly" title="Yearly">
      <div className='row p-3'>
                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$549<span>/Month</span></p>
                            <ul className='features'>
                                <li>3-5 day turnaround</li>
                                <li>Native development</li>
                                <li>Task delivered one-by-one</li>
                                <li>Dedicated dashboard</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>

                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$649<span>/Month</span></p>
                            <ul className='features'>
                                <li>1-2 day turnaround</li>
                                <li>Monthly strategy call</li>
                                <li>Commercial licence</li>
                                <li>Native development</li>
                                <li>Task delivered one-by-one</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>

                        <div className='col-md-4 col-12 p-3'>
                            <div className='card subscriptionCard'>
                                <h3 className='text-white text-center'>Basic Plan</h3>
                                <p className='amount'>$1049<span>/Month</span></p>
                            <ul className='features'>
                                <li>Everything in design & development</li>
                                <li>Strategy workshop</li>
                                <li>Priority support</li>
                                <li>Multiple task at once</li>
                                <li>Dedicated dashboard</li>
                                <li>Adavance custom development</li>
                            </ul>

                            <button className='slctPlanBtn'>Choose Plan</button>
                            </div>
                        </div>
                    </div>
      </Tab>
      
    </Tabs>
                        </div> 
                   
                    </div>
                    {/* <img src={LeftSideImg} className='LeftSideImg' alt="" />
                    <img src={RightSideImg} className="RightSideImg" alt="" /> */}
                </div>
            </section>
        </>
    )
}

export default Subscription;
